import styled from 'styled-components';

export const FullscreenButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
`;

export const InnerContent = styled.div`
  cursor: pointer;
  background: none;
  width: 32px;
  border-radius: 6px;
  color: #fff;
  height: 32px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  text-shadow: 1px 1px #000;
`;
